export default "__VITE_ASSET__eae93132__"